var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BAlert',{attrs:{"show":"","variant":"danger"}},[_c('i',{staticClass:"material-icons-outlined"},[_vm._v(" error_outline ")]),_vm._v(" "+_vm._s(_vm.$t('autoAccess.access.dataSources.errorMessages.invalidJSONL'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }